"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTealiumEventValid = exports.canDispatchTealiumEventData = exports.loggedEvents = void 0;
var tealium_analytics_model_1 = require("./tealium-analytics.model");
exports.loggedEvents = {};
function canDispatchTealiumEventData(tagData, data, sendOptions) {
    var dispatchKeyCategory = data.context.join('|');
    var keyEventName = data.eventName || '';
    var keyEventData = tagData.event_data;
    exports.loggedEvents[dispatchKeyCategory] = exports.loggedEvents[dispatchKeyCategory] || {};
    var isAlreadyDispatchedResponse = function () {
        return exports.loggedEvents[dispatchKeyCategory].hasOwnProperty(keyEventName) &&
            exports.loggedEvents[dispatchKeyCategory][keyEventName] === keyEventData;
    };
    if (!sendOptions.sendOnlyNewEvents || (sendOptions.sendOnlyNewEvents && !isAlreadyDispatchedResponse())) {
        exports.loggedEvents[dispatchKeyCategory][keyEventName] = keyEventData;
        return true;
    }
    else {
        exports.loggedEvents[dispatchKeyCategory][keyEventName] = keyEventData;
        return false;
    }
}
exports.canDispatchTealiumEventData = canDispatchTealiumEventData;
function isTealiumEventValid(event) {
    if (event.context.length === 0) {
        // tslint:disable-next-line:no-console
        console.error(tealium_analytics_model_1.consoleName + ": Contexts not defined when trying to send analytics data event");
        return false;
    }
    if (!event.signupFlowName || (Array.isArray(event.signupFlowName) && event.signupFlowName.length === 0)) {
        // tslint:disable-next-line:no-console
        console.error(tealium_analytics_model_1.consoleName + ": Sign up flow name not defined when trying to send analytics data event");
        return false;
    }
    return true;
}
exports.isTealiumEventValid = isTealiumEventValid;
